// Canonical production site URL (override via REACT_APP_SITE_URL at build time).
export const SITE_URL = process.env.REACT_APP_SITE_URL || "https://valdisoleapartments.it";

export const BUSINESS = {
  name: "Appartamenti in Val di Sole",
  phone: "+39 379 141 3251",
  phoneHref: "+393791413251",
  email: "appartamentovaldisole@gmail.com",
  locality: "Dimaro Folgarida",
  region: "Trentino-Alto Adige",
  postalCode: "38025",
  country: "IT",
};

// Dati per informativa Privacy & Cookie. Aggiorna company/vat con i dati reali del titolare.
export const LEGAL = {
  company: "Bruno Giuseppe",
  vat: "C.F. BRNGPP82A03B774U",
  address: "Via dei lavatori 3, 38025 Dimaro Folgarida (TN), Italia",
  email: "appartamentovaldisole@gmail.com",
  phone: "+39 379 141 3251",
  updated: "Luglio 2026",
};

// SEO-friendly apartment URL (falls back to legacy UUID path if slug missing)
export function aptUrl(a) {
  if (a && a.slug) return `/appartamenti/${a.localita || "dimaro-folgarida"}/${a.slug}`;
  return `/appartamento/${a && a.id ? a.id : ""}`;
}
